// extracted by mini-css-extract-plugin
export default {"mainContainer":"productLanding_mainContainer__A+FNv","leftContainer":"productLanding_leftContainer__kaxcj","rightContainer":"productLanding_rightContainer__m+f-y"};